<c-container class="mt-5">
  <h2>Player Email History</h2>
  <c-row>
    <c-col md="4">
      <mat-card class="mb-4 padding-med margin-top-med">
        <h6>Please populate at least one field to search for player email changes</h6>
        <form [formGroup]="emailHistoryForm">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Old Email</mat-label>
            <input matInput formControlName="oldEmail" type="text" data-testid="email-history-old-email-input">
            <mat-error>Please enter a valid email address</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>New Email</mat-label>
            <input matInput formControlName="newEmail" type="text" data-testid="email-history-new-email-input">
            <mat-error>Please enter a valid email address</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Player Id</mat-label>
            <input matInput formControlName="playerId" type="text" data-testid="email-history-player-id-input">
            <mat-error>Please enter a valid GUID</mat-error>
          </mat-form-field>
        </form>

        <button mat-flat-button
                color="primary"
                (click)="onSearchButtonClick()"
                data-testid="player-email-history-search-button">
          Search
        </button>

        <button mat-stroked-button
                class="margin-top-small"
                color="warn"
                (click)="onResetButtonClick()"
                data-testid="player-email-history-reset-button">
          Clear
        </button>

      </mat-card>

    </c-col>

    <c-col>
      <ag-grid-angular
        id="playerEmailHistoryGrid"
        class="ag-theme-quartz margin-top-med margin-bottom-med"
        data-testid="player-email-history-grid"
        [tooltipShowDelay]="0"
        rowClass="table-row"
        domLayout="autoHeight"
        (gridReady)="onEmailHistoryGridReady($event)"
        [loading]="uiState == uiStateEnum.ShowLoading"
        [rowData]="playerEmails"
        [columnDefs]="emailHistoryColDefs">
      </ag-grid-angular>
    </c-col>
  </c-row>
</c-container>
